import { LazyImage, Overlay, styled } from '@teko/ds-desktop';
import { SmallImage, Gallery } from '@teko/teko-ecommerce';
import { useProductDetailState } from 'contexts';
import React, { useState } from 'react';
import { getTrackingData } from '@teko/tracking';

export const ProductImages: React.FC = () => {
  const { product, frame } = useProductDetailState();
  const [showGallery, setShowGallery] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const images = product?.images;
  return (
    <div
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'imgProductDetail',
        contentName: 'viewImage',
        target: 'productImage',
        payload: JSON.stringify({
          sku: product.sku,
          screenName: 'productDetail',
          index: activeIndex,
        }),
      })}
    >
      <div
        style={{
          cursor: 'pointer',
          position: 'relative',
          marginBottom: '0.5rem',
        }}
        className="productDetailPreview" // class for pushdy banner
      >
        {frame && <FrameWrapper frame={frame} />}
        <LazyImage
          contain
          {...images[activeIndex]}
          onClick={() => setShowGallery(true)}
          borderRadius={8}
          imageWidth={500}
        />
      </div>
      <WrapperSmallImages>
        {images.slice(0, 6).map((img, index) => (
          <SmallImage
            key={index}
            image={img}
            alt={img.alt}
            isActive={index === activeIndex}
            onClick={() => setShowGallery(true)}
            onMouseEnter={() =>
              !(index === 5 && images.length > 6) && setActiveIndex(index)
            }
            extra={
              index === 5 && images.length > 6
                ? `+${images.length - 6}`
                : undefined
            }
          />
        ))}
      </WrapperSmallImages>
      <Overlay show={showGallery} onEscPressed={() => setShowGallery(false)}>
        <Gallery
          images={images}
          bgColor="white"
          onClose={() => setShowGallery(false)}
          activeImageIndex={activeIndex}
        />
      </Overlay>
    </div>
  );
};

const WrapperSmallImages = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;
`;

interface FrameWrapperStyledProps {
  frame: string;
}

const FrameWrapper = styled.div<FrameWrapperStyledProps>(
  ({ frame }: FrameWrapperStyledProps) => `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  background-image: url(${frame});
  background-size: cover;
  height: 100%;
  width: 100%;
  cursor: pointer;
  `,
);
